<template>
  <div class="article-list">
    <div
      v-for="article in filteredArticles"
      :key="article.id"
      @click="goToDetail(article.id)"
    >
      <div v-if="activeTab === 'all'" class="article-with-image">
        <img :src="article.image" alt="article image" />
        <div class="article-info">
          <h3>{{ article.title }}</h3>
          <p>{{ article.date }}</p>
        </div>
      </div>
      <div v-else class="article-plain">
        <h3>{{ article.title }}</h3>
        <p>{{ article.date }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

const props = defineProps(["activeTab"]);
const router = useRouter();

// 模拟数据，实际开发中从后端获取
const allArticles = ref([
  {
    id: 1,
    image: require("@/assets/22.jpg"),
    title: "高考志愿填报怎么填报，高考...",
    date: "2025-05-19",
  },
  {
    id: 2,
    image: require("@/assets/33.jpg"),
    title: "理科女生最吃香的十大专业，...",
    date: "2025-05-19",
  },
  {
    id: 3,
    image: require("@/assets/xuanchuanye.jpg"),
    title: "2025年高考文科生专业选择指...",
    date: "2025-05-19",
  },
]);

const hotArticles = ref([
  { id: 4, title: "理科女生最吃香的十大专业有哪些?", date: "05-19" },
  { id: 5, title: "大学理科专业有哪些? 2025年学科布...", date: "05-19" },
]);

const schoolArticles = ref([
  { id: 6, title: "报考志愿滑档怎么办? 2025年最新数...", date: "05-19" },
  { id: 7, title: "填报志愿机构收费标准是什么? 哪个...", date: "05-19" },
]);

const volunteerArticles = ref([
  { id: 8, title: "2025年志愿填报理科生可以报哪些专...", date: "05-16" },
  { id: 9, title: '如果专业是盲盒，这份"隐藏款"概率...', date: "05-16" },
]);

const filteredArticles = computed(() => {
  switch (props.activeTab) {
    case "all":
      return allArticles.value;
    case "hot":
      return hotArticles.value;
    case "school":
      return schoolArticles.value;
    case "volunteer":
      return volunteerArticles.value;
    default:
      return allArticles.value;
  }
});

const goToDetail = (id) => {
  router.push({ name: "NewsDetail", params: { id } });
};
</script>

<style scoped>
.article-list {
  display: flex;
  margin: 50px auto;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}

.article-with-image {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.article-with-image img {
  width: 100%;
  height: auto;
  display: block;
}

.article-info {
  padding: 10px;
}

.article-plain {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
}
</style>
